import { applyMiddleware, createStore } from "redux";
import cartReducer from "./shopping_cart/CartReducer";

const maxHandler = (store) => (next) => (action) => {
    // Checking total stock from action
    const stock = action.payload.stock;

    // Getting State
    const state = store.getState();

    // Check total sold
    const sold = state[`${action.payload.product}`].items;

    // Validation
    if (sold >= stock) {
        alert("already sold");
    } else {
        return next(action);
    }
};

const store = createStore(cartReducer, applyMiddleware(maxHandler));

export default store;
